import { connect } from 'react-redux';
import { compose } from 'redux';
import isNil from 'lodash/isNil';
import { KeepFocusHoc } from '@Hooks/KeepFocus';
import { dialog } from '../DialogsSelectors';

import BaseDialogLayout from './BaseDialogLayout';
import BaseDialogLayoutMovableHoc from './BaseDialogLayoutMovableHoc';
import BaseDialogLayoutAppearHoc from './BaseDialogLayoutAppearHoc';

function mapStateToProps(state, ownProps) {
  return {
    ...dialog(state, ownProps),
    ...ownProps,
  };
}

export default compose(
  connect(mapStateToProps),
  KeepFocusHoc({
    focusOnMount: true,
    needKeepFocus: (props) => (!isNil(props.needKeepFocus) ? props.needKeepFocus : true),
  }),
  BaseDialogLayoutMovableHoc,
  BaseDialogLayoutAppearHoc
)(BaseDialogLayout);
